import React from "react";
import PropTypes from "prop-types";
import { Table, Button, ModalFooter } from "reactstrap";

const propTypes = {
  cancelFlowData: PropTypes.shape({
    zip_spots_info: PropTypes.arrayOf(
      PropTypes.shape({
        postal_code: PropTypes.string.isRequired,
        spot_type: PropTypes.string.isRequired,
        num_agents_on_wait_list: PropTypes.number.isRequired
      })
    )
  }).isRequired,
  onContinue: PropTypes.func.isRequired,
  onKeep: PropTypes.func.isRequired
};

const SoldOutZipsStep = ({ cancelFlowData, onContinue, onKeep }) => {
  const zips = Object.values(cancelFlowData?.zip_spots_info || {}).filter(z => z["sold_out?"]);
  const alertTitle = zips.length === 1 ? "One of them is sold out." : "Some are sold out.";

  return (
    <div>
      <p className="text-center font-weight-bold mb-1">
        Just to let you know, your competitors want to reach sellers in your zip codes too&hellip;
      </p>
      <p className="text-center text-muted mb-3">{alertTitle}</p>

      <Table bordered hover size="sm" className="mb-3">
        <tbody>
          {zips.map(z => (
            <tr key={`${z.postal_code}-${z.spot_type}`}>
              <td>
                {z.postal_code} {z.spot_type} spots
              </td>
              <td>Sold out</td>
              {z.num_agents_on_wait_list > 0 && (
                <td className="text-warning">
                  with {z.num_agents_on_wait_list} agents on the Waiting List
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </Table>

      <p className="text-center text-muted mb-0">
        If you cancel, you may not be able to advertise in your zip codes in the future.
      </p>

      <ModalFooter className="pt-2 px-0">
        <Button color="secondary" className="btn-sharp" onClick={onContinue}>
          Release Zip Codes
        </Button>
        <Button color="primary" className="btn-sharp" onClick={onKeep}>
          Keep My Zip Codes
        </Button>
      </ModalFooter>
    </div>
  );
};

SoldOutZipsStep.propTypes = propTypes;

export default SoldOutZipsStep;
